<template>
    <v-container max-width="100%" style="margin-top: 2%;">
        <template>
            <v-row justify="center">
                <v-dialog v-model="confirmDialog" persistent max-width="500">
                    <v-card>
                        <v-card-title class="headline">
                            <span style="color: #d60000">{{ $t('system.alert') }}</span>
                        </v-card-title>
                        <v-card-text>
                            <span style="color: #d60000">{{ this.mensagemdialog }}</span>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="red accent-4" class="white--text" @click="confirmDialog = false">{{
                                $t('button.dismiss') }}</v-btn>
                            <v-btn v-if="showConfirmButton" color="red accent-4" class="white--text"
                                @click="deleteFromDatabase">{{ $t('button.confirm') }}</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-row>
        </template>
        <merus-data-table :headers="headers" :items="turnos" :loading="loadingtable"
            :default-multi-sort="defaultSort" :loading-text="$t('turnos.loading')" @update:displayedItems="displayedItemsForExport = $event"

 cod-tabela="TURNOS" @update:headers="headers = $event">
            <template v-slot:toolbar>
                <CadastroToolbar :title="$t('turnos.title')" :token="token" :items="displayedItemsForExport !== null ? displayedItemsForExport : turnos" :csv-title="$t('turnos.title')"
                    :pdf-title="$t('turnos.title')" :pdf-headers="headers" :pdf-filename="$t('turnos.title')" hide-search>
                    <template v-slot:add v-if="canInsert">
                        <v-dialog v-model="dialog" max-width="80%">
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn color="primary" dark small class="mb-2" v-bind="attrs" v-on="on" fab>
                                    <v-icon>mdi-plus</v-icon>
                                </v-btn>
                            </template>
                            <v-card>
                                <v-toolbar dark color="primary" ref="myToolbar">
                                    <v-btn icon dark @click="close">
                                        <v-icon>mdi-close</v-icon>
                                    </v-btn>
                                    <v-toolbar-title>{{ $tc('turnos.self', 1) }}</v-toolbar-title>
                                </v-toolbar>

                                <v-card-text>
                                    <v-container>
                                        <v-form ref="form" v-model="formValidado">
                                            <v-row>
                                                <v-col cols="12" sm="6" md="3">
                                                    <v-text-field v-model="editedItem.cod_turno" :label="$t('turnos.headers.code')"
                                                        :rules="[(v) => !!v || $t('rules.messageName')]"></v-text-field>
                                                </v-col>

                                                <v-col cols="12" sm="6" md="3">
                                                    <v-text-field v-model="editedItem.descricao_turno"
                                                        :label="$t('turnos.headers.description')"
                                                            :rules="[(v) => !!(v && String(v).trim()) || $t('rules.messageDescription')]"></v-text-field>
                                                    </v-col>

                                                <v-col cols="12" sm="6" md="2">
                                                    <v-select v-model="editedItem.id_unidade" :items="unidades" item-text="cod_unidade"
                                                        item-value="id_unidade" :label="$t('turnosPassageiros.headers.unit')" clearable></v-select>
                                                </v-col>

                                            </v-row>
                                            <v-row>
                                                <v-col cols="12" sm="6" md="3">
                                                    <v-text-field v-model="editedItem.raio_ideal_ida" :label="$t('turnos.headers.idealRadiusIda')"
                                                        clearable suffix="m"
                                                        :rules="[ruleRadius, ruleIdealAteMaximo('ida')]"></v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="6" md="3">
                                                    <v-text-field v-model="editedItem.raio_maximo_ida" :label="$t('turnos.headers.maximumRadiusIda')"
                                                        clearable suffix="m"
                                                        :rules="[ruleRadius]"></v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="6" md="3">
                                                    <v-text-field v-model="editedItem.raio_ideal_volta" :label="$t('turnos.headers.idealRadiusVolta')"
                                                        clearable suffix="m"
                                                        :rules="[ruleRadius, ruleIdealAteMaximo('volta')]"></v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="6" md="3">
                                                    <v-text-field v-model="editedItem.raio_maximo_volta" :label="$t('turnos.headers.maximumRadiusVolta')"
                                                        clearable suffix="m"
                                                        :rules="[ruleRadius]"></v-text-field>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12" sm="2" md="2">
                                                    <span style="font-weight: bold;">{{ $t('turnosPassageiros.headers.validMonday') }}</span>
                                                </v-col>
                                                <v-col cols="12" sm="3" md="3">
                                                    <v-text-field 
                                                    v-model="editedItem.horario_inicio_segunda" :label="$t('turnosPassageiros.arrivalTime')"
                                                    prepend-icon="mdi-clock" v-mask="'##:##'" solo></v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="3" md="3">
                                                    <v-text-field 
                                                    v-model="editedItem.horario_fim_segunda" :label="$t('turnosPassageiros.departureTime')"
                                                    prepend-icon="mdi-clock" v-mask="'##:##'" solo></v-text-field>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12" sm="2" md="2">
                                                    <span style="font-weight: bold;">{{ $t('turnosPassageiros.headers.validTuesday') }}</span>
                                                </v-col>
                                                <v-col cols="12" sm="3" md="3">
                                                    <v-text-field 
                                                    v-model="editedItem.horario_inicio_terca" :label="$t('turnosPassageiros.arrivalTime')"
                                                    prepend-icon="mdi-clock" v-mask="'##:##'" solo></v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="3" md="3">
                                                    <v-text-field 
                                                    v-model="editedItem.horario_fim_terca" :label="$t('turnosPassageiros.departureTime')"
                                                    prepend-icon="mdi-clock" v-mask="'##:##'" solo></v-text-field>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12" sm="2" md="2">
                                                    <span style="font-weight: bold;">{{ $t('turnosPassageiros.headers.validWednesday') }}</span>
                                                </v-col>
                                                <v-col cols="12" sm="3" md="3">
                                                    <v-text-field 
                                                    v-model="editedItem.horario_inicio_quarta" :label="$t('turnosPassageiros.arrivalTime')"
                                                    prepend-icon="mdi-clock" v-mask="'##:##'" solo></v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="3" md="3">
                                                    <v-text-field 
                                                    v-model="editedItem.horario_fim_quarta" :label="$t('turnosPassageiros.departureTime')"
                                                    prepend-icon="mdi-clock" v-mask="'##:##'" solo></v-text-field>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12" sm="2" md="2">
                                                    <span style="font-weight: bold;">{{ $t('turnosPassageiros.headers.validThursday') }}</span>
                                                </v-col>
                                                <v-col cols="12" sm="3" md="3">
                                                    <v-text-field 
                                                    v-model="editedItem.horario_inicio_quinta" :label="$t('turnosPassageiros.arrivalTime')"
                                                    prepend-icon="mdi-clock" v-mask="'##:##'" solo></v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="3" md="3">
                                                    <v-text-field 
                                                    v-model="editedItem.horario_fim_quinta" :label="$t('turnosPassageiros.departureTime')"
                                                    prepend-icon="mdi-clock" v-mask="'##:##'" solo></v-text-field>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12" sm="2" md="2">
                                                    <span style="font-weight: bold;">{{ $t('turnosPassageiros.headers.validFriday') }}</span>
                                                </v-col>
                                                <v-col cols="12" sm="3" md="3">
                                                    <v-text-field 
                                                    v-model="editedItem.horario_inicio_sexta" :label="$t('turnosPassageiros.arrivalTime')"
                                                    prepend-icon="mdi-clock" v-mask="'##:##'" solo></v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="3" md="3">
                                                    <v-text-field 
                                                    v-model="editedItem.horario_fim_sexta" :label="$t('turnosPassageiros.departureTime')"
                                                    prepend-icon="mdi-clock" v-mask="'##:##'" solo></v-text-field>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12" sm="2" md="2">
                                                    <span style="font-weight: bold;">{{ $t('turnosPassageiros.headers.validSaturday') }}</span>
                                                </v-col>
                                                <v-col cols="12" sm="3" md="3">
                                                    <v-text-field 
                                                    v-model="editedItem.horario_inicio_sabado" :label="$t('turnosPassageiros.arrivalTime')"
                                                    prepend-icon="mdi-clock" v-mask="'##:##'" solo></v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="3" md="3">
                                                    <v-text-field 
                                                    v-model="editedItem.horario_fim_sabado" :label="$t('turnosPassageiros.departureTime')"
                                                    prepend-icon="mdi-clock" v-mask="'##:##'" solo></v-text-field>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12" sm="2" md="2">
                                                    <span style="font-weight: bold;">{{ $t('turnosPassageiros.headers.validSunday') }}</span>
                                                </v-col>
                                                <v-col cols="12" sm="3" md="3">
                                                    <v-text-field 
                                                    v-model="editedItem.horario_inicio_domingo" :label="$t('turnosPassageiros.arrivalTime')"
                                                    prepend-icon="mdi-clock" v-mask="'##:##'" solo></v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="3" md="3">
                                                    <v-text-field 
                                                    v-model="editedItem.horario_fim_domingo" :label="$t('turnosPassageiros.departureTime')"
                                                    prepend-icon="mdi-clock" v-mask="'##:##'" solo></v-text-field>
                                                </v-col>
                                            </v-row>
                                        </v-form>
                                    </v-container>
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn dark color="primary" @click="close">{{ $t('button.cancel') }}</v-btn>
                                    <v-btn dark color="primary" @click="save">{{ $t('button.save') }}</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                    </template>
                </CadastroToolbar>

            </template>
            <template v-slot:item.segunda="{ item }">
                <v-icon v-if="item.horario_inicio_segunda == null || item.horario_fim_segunda == null" color="grey" small>mdi-minus</v-icon>
                <v-icon v-else color="green" small>mdi-clock-outline</v-icon>
                <span v-if="item.horario_inicio_segunda != null && item.horario_fim_segunda != null" style="margin-left: 5px; font-size: 12px;">{{ item.horario_inicio_segunda }} - {{ item.horario_fim_segunda }}</span>
            </template>
            <template v-slot:item.terca="{ item }">
                <v-icon v-if="item.horario_inicio_terca == null || item.horario_fim_terca == null" color="grey" small>mdi-minus</v-icon>
                <v-icon v-else color="green" small>mdi-clock-outline</v-icon>
                <span v-if="item.horario_inicio_terca != null && item.horario_fim_terca != null" style="margin-left: 5px; font-size: 12px;">{{ item.horario_inicio_terca }} - {{ item.horario_fim_terca }}</span>
            </template>
            <template v-slot:item.quarta="{ item }">
                <v-icon v-if="item.horario_inicio_quarta == null || item.horario_fim_quarta == null" color="grey" small>mdi-minus</v-icon>
                <v-icon v-else color="green" small>mdi-clock-outline</v-icon>
                <span v-if="item.horario_inicio_quarta != null && item.horario_fim_quarta != null" style="margin-left: 5px; font-size: 12px;">{{ item.horario_inicio_quarta }} - {{ item.horario_fim_quarta }}</span>
            </template>
            <template v-slot:item.quinta="{ item }">
                <v-icon v-if="item.horario_inicio_quinta == null || item.horario_fim_quinta == null" color="grey" small>mdi-minus</v-icon>
                <v-icon v-else color="green" small>mdi-clock-outline</v-icon>
                <span v-if="item.horario_inicio_quinta != null && item.horario_fim_quinta != null" style="margin-left: 5px; font-size: 12px;">{{ item.horario_inicio_quinta }} - {{ item.horario_fim_quinta }}</span>
            </template>
            <template v-slot:item.sexta="{ item }">
                <v-icon v-if="item.horario_inicio_sexta == null || item.horario_fim_sexta == null" color="grey" small>mdi-minus</v-icon>
                <v-icon v-else color="green" small>mdi-clock-outline</v-icon>
                <span v-if="item.horario_inicio_sexta != null && item.horario_fim_sexta != null" style="margin-left: 5px; font-size: 12px;">{{ item.horario_inicio_sexta }} - {{ item.horario_fim_sexta }}</span>
            </template>
            <template v-slot:item.sabado="{ item }">
                <v-icon v-if="item.horario_inicio_sabado == null || item.horario_fim_sabado == null" color="grey" small>mdi-minus</v-icon>
                <v-icon v-else color="green" small>mdi-clock-outline</v-icon>
                <span v-if="item.horario_inicio_sabado != null && item.horario_fim_sabado != null" style="margin-left: 5px; font-size: 12px;">{{ item.horario_inicio_sabado }} - {{ item.horario_fim_sabado }}</span>
            </template>
            <template v-slot:item.domingo="{ item }">
                <v-icon v-if="item.horario_inicio_domingo == null || item.horario_fim_domingo == null" color="grey" small>mdi-minus</v-icon>
                <v-icon v-else color="green" small >mdi-clock-outline</v-icon>
                <span v-if="item.horario_inicio_domingo != null && item.horario_fim_domingo != null" style="margin-left: 5px; font-size: 12px;">{{ item.horario_inicio_domingo }} - {{ item.horario_fim_domingo }}</span>
            </template>

            <template v-slot:item.actions="{ item }">
                <v-icon small class="mr-2" color="green" @click="editItem(item)" :disabled="!canEdit">mdi-pencil</v-icon>
                <v-icon small class="mr-2" color="red" @click="deleteItem(item)" :disabled="!canDelete">mdi-delete</v-icon>
            </template>
        </merus-data-table>
    </v-container>
</template>

<script>

    import apiController from "@/utils/apiController";
    import MerusDataTable from "./Tables/MerusDataTable.vue";
    import CadastroToolbar from "./Toolbars/CadastroToolbar.vue";
    import EventBus from "../utils/eventBus";

export default {
    components: {
        MerusDataTable,
        CadastroToolbar
    },
    data: () => ({
    headers: [],
        turnos: [],
        unidades: [],
        search: "",
        loadingtable: true,
        tipoAlerta: "success",
        showAlert: false,
        mensagemAlerta: "",
        confirmDialog: false,
        mensagemdialog: "",
        showConfirmButton: true,
        authDialog: false,
        formValidado: true,
        dialog: false,
        sysError: null,
        editedIndex: -1,
        editedItem: {
            id_turno: null,
            cod_turno: null,
            descricao_turno: null,
            horario_inicio_segunda: null,
            horario_fim_segunda: null,
            horario_inicio_terca: null,
            horario_fim_terca: null,
            horario_inicio_quarta: null,
            horario_fim_quarta: null,
            horario_inicio_quinta: null,
            horario_fim_quinta: null,
            horario_inicio_sexta: null,
            horario_fim_sexta: null,
            horario_inicio_sabado: null,
            horario_fim_sabado: null,
            horario_inicio_domingo: null,
            horario_fim_domingo: null,
            raio_ideal_ida: null,
            raio_maximo_ida: null,
            raio_ideal_volta: null,
            raio_maximo_volta: null,
            id_unidade: null,
        },
        deletedItem: {
            id_turno: null,
            cod_turno: null,
            descricao_turno: null,
            horario_inicio_segunda: null,
            horario_fim_segunda: null,
            horario_inicio_terca: null,
            horario_fim_terca: null,
            horario_inicio_quarta: null,
            horario_fim_quarta: null,
            horario_inicio_quinta: null,
            horario_fim_quinta: null,
            horario_inicio_sexta: null,
            horario_fim_sexta: null,
            horario_inicio_sabado: null,
            horario_fim_sabado: null,
            horario_inicio_domingo: null,
            horario_fim_domingo: null,
            raio_ideal_ida: null,
            raio_maximo_ida: null,
            raio_ideal_volta: null,
            raio_maximo_volta: null,
            id_unidade: null,
        },
        defaultItem: {
            id_turno: null,
            cod_turno: null,
            descricao_turno: null,
            horario_inicio_segunda: null,
            horario_fim_segunda: null,
            horario_inicio_terca: null,
            horario_fim_terca: null,
            horario_inicio_quarta: null,
            horario_fim_quarta: null,
            horario_inicio_quinta: null,
            horario_fim_quinta: null,
            horario_inicio_sexta: null,
            horario_fim_sexta: null,
            horario_inicio_sabado: null,
            horario_fim_sabado: null,
            horario_inicio_domingo: null,
            horario_fim_domingo: null,
            raio_ideal_ida: null,
            raio_maximo_ida: null,
            raio_ideal_volta: null,
            raio_maximo_volta: null,
            id_unidade: null,
        },
        recursos: [],
        canInsert: false,
        canEdit: false,
        canDelete: false,
    }),
    computed: {

        defaultSort() {
            return [
                { value: 'cod_turno', options: { text: this.$t('turnos.increasing'), value: 1 } }]
        },

    },
    watch: {
        '$i18n.locale'() {
            this.initialize();
            if (this.$refs.form) {
                this.$refs.form.resetValidation();
            }
        }
    },
    created() {
        this.user = JSON.parse(sessionStorage.getItem("user"));
        this.token = sessionStorage.getItem("api");
        this.populaUnidades();
        this.populaRecursos();
    },
    methods: {

        isEmptyRadiusValue(v) {
            return v === null || v === undefined || String(v).trim() === '';
        },
        /** Vazio = válido (nulo no banco). Preenchido = inteiro estrito > 0. */
        ruleRadius(v) {
            if (this.isEmptyRadiusValue(v)) return true;
            const s = String(v).trim();
            if (!/^[1-9]\d*$/.test(s)) return this.$t('rules.messageRadius');
            return true;
        },
        /** Raio ideal não pode passar do máximo do mesmo sentido (só quando os dois vêm preenchidos). */
        ruleIdealAteMaximo(sentido) {
            return (v) => {
                const max = this.editedItem[`raio_maximo_${sentido}`];
                if (this.isEmptyRadiusValue(v) || this.isEmptyRadiusValue(max)) return true;
                return Number(v) <= Number(max) || this.$t('rules.messageRadiusIdealAboveMax');
            };
        },
        populaUnidades() {
            apiController.request(apiController.endpoints.getallUnidadesativas, {
                onSuccess: (response) => {
                    this.unidades = response.data;
                },
            });
        },
        populaRecursos() {
            if (this.user.is_superadmin === 1) {
                apiController.request(apiController.endpoints.getallRecursos, {
                    onSuccess: (response) => {
                        this.recursos = response.data;
                        this.canEdit = true;
                        this.canInsert = true;
                        this.canDelete = true;
                        this.initialize();
                    },
                });
            } else {
                apiController.request(apiController.endpoints.getRecursosusuario, {
                    params: { id: this.user.id_usuario },
                    onSuccess: (response) => {
                        this.recursos = response.data;
                        this.canEdit = this.recursos.some((r) => r.rota === "/api/v1.0/updateturno");
                        this.canInsert = this.recursos.some((r) => r.rota === "/api/v1.0/insertturno");
                        this.canDelete = this.recursos.some((r) => r.rota === "/api/v1.0/deleteturno");
                        this.initialize();
                    },
                });
            }
        },
        initialize() {
            apiController.request(apiController.endpoints.getallTurnos, {
                silent: true,
                onSuccess: (response) => {
                    this.turnos = response.data;
                    this.loadingtable = false;
                },
                onError: (e) => {
                    console.log(e);
                    this.sysError = e;
                    this.authDialog = true;
                },
            });
        },
        close() {
            this.dialog = false;
            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.deletedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            });
        },
        editItem(item) {
            this.editedIndex = this.turnos.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.operacao = 1;
            this.dialog = true;
        },
        deleteItem(item) {
            this.deletedItem = Object.assign({}, item);
            this.operacao = 2;
            this.mensagemdialog = this.$t('turnos.deleteTurno') + ` ${this.deletedItem.descricao_turno}?`
            this.messageConfirmButton = this.$t('button.delete');
            this.messageDismissButton = this.$t('button.cancel');
            this.showConfirmButton = true;
            this.confirmDialog = true;
        },
        deleteFromDatabase() {
            apiController.request(apiController.endpoints.deleteTurno, {
                    data: this.deletedItem,
                    onSuccess: (response) => {
                        this.updateTable(response.data.erro);
                        this.confirmDialog = false;
                    },
                    onError: () => {
                        this.confirmDialog = false;
                    },
                });
            },
            /**
             * Corpo do insert/update: só os campos do turno, com os 4 raios por sentido como
             * inteiro ou null. O item da tabela traz colunas de exibição (cod_unidade, ...) que
             * não vão para a API.
             */
            buildPayload() {
                const item = this.editedItem;
                const payload = {};
                Object.keys(this.defaultItem).forEach((key) => {
                    payload[key] = item[key] === undefined ? null : item[key];
                });
                ['raio_ideal_ida', 'raio_maximo_ida', 'raio_ideal_volta', 'raio_maximo_volta'].forEach((key) => {
                    payload[key] = this.isEmptyRadiusValue(item[key]) ? null : Number(String(item[key]).trim());
                });
                return payload;
            },
            save(){
                // validate() devolve o resultado na hora; formValidado (v-model) pode estar defasado
                const valido = this.$refs.form.validate();
                if (valido) {
                    if (this.editedIndex == -1) {
                        this.operacao = 0;

                    apiController.request(apiController.endpoints.insertTurno, {
                        data: this.buildPayload(),
                        onSuccess: (response) => {
                            this.updateTable(response.data.erro);
                        },
                    });
                } else {
                    this.operacao = 1;
                    apiController.request(apiController.endpoints.updateTurno, {
                        data: this.buildPayload(),
                        onSuccess: (response) => {
                            this.updateTable(response.data.erro);
                        },
                    });
                }
            }
        },
        updateTable(status) {
                let mensagem = "";
                let tipo = status ? "error" : "success";
                
            if (status) {
                if (this.operacao == 0) {
                    mensagem = this.$t('turnos.alerts.error.insert');
                } else {
                    if (this.operacao == 1) {
                        mensagem = this.$t('turnos.alerts.error.update');
                    } else {
                        mensagem = this.$t('turnos.alerts.error.delete');
                    }
                    }
                } else {
                    if (this.operacao == 0) {
                    mensagem = this.$t('turnos.alerts.success.insert');
                    } else {
                    if (this.operacao == 1) {
                        mensagem = this.$t('turnos.alerts.success.update');
                    } else {
                        mensagem = this.$t('turnos.alerts.success.delete');
                    }
                    }
                }
                
                EventBus.$emit('show-alert', { mensagem, tipo });
                this.close();
                this.initialize();
            },
        },
    }
</script>

